define([
	"dojo/_base/declare",
	"csi/heading/NumberController",
	"csi/types",
	"csi/xml",
	"ProductSpec/SizeChart",
	"./_VectorController"
], function(declare,NumberController,types,xml,SizeChart,_VectorController) {

	return declare(_VectorController, {
		process: function() {
			// summary: if value is position and before the base size, then negate it (and vice-versa)
			this.newValue = this.newValue === "" ? this.newValue : types.getInternalNumber(this.newValue);
			if ((this.newValue > 0) &&
				!this._isPositiveValue() &&
				!this.ren.isAbsoluteDisplay(this._ctx) &&
				(this.keyContainer < this._getBaseIndex(this.keyContainer))) {
				this.newValue = -this.newValue;
			}

			this.inherited(arguments);
		},

		_isValueChanged: function() {
			// summary: if blank dimension, then any value is a change for non-base size values
			if (this.getNode().Blanks && !this._subSizeRanges.isBaseIndex(this.keyContainer)) {
				// this function can be called later in the controller after the editNode is destroyed, so at that point
				// the endStatus will indicate if a valid value was entered; and we cannot test for "newValue" because
				// it is 0 even when edit field is left blank - we need to test the string value to see if it is empty or not
				return !!this.getInlineEditValue() || !!this.endStatus;
			}

			return this.inherited(arguments);
		},

		_toWriterValue: function(/*String*/id, /*String*/type) {
			// summary: compute changes to increment and absolute values
			var	index = this.keyContainer;
			var	baseIndex = this._getBaseIndex(index);
			var	cn;

			if (index == baseIndex) {
				// if base size value changed, then update that value as usual and store as revised value
				// so that it won't be lost when changing size range or increment
				cn = this.inherited(arguments);
			} else {
				if (!this.ren.isIncrementDisplay(this._ctx)) {
					// adjust increment values to compensate for change to absolute value
					var	dDiff = SizeChart.sumDoubleValues(this.newValue, -this.oldValue);
					var	dimValues = SizeChart.getDimensionValues(this._ctx, id);
					var	value = {};

					if (SizeChart.isNotInitialized(this.newValue)) {
						value[index] = this.ren.DEFAULT;
						dDiff = -dimValues.inc[index];
					} else if (SizeChart.isNotInitialized(this.oldValue)) {
						var comparingIndex = this._getIndexOfValidCellCloserToBase(index, baseIndex, dimValues.inc);
						var comparingValue = (this.ren.isAbsoluteDisplay(this._ctx)) ?
								dimValues.absIgnoreBlank[comparingIndex] :
									SizeChart.sumDoubleValues(dimValues.absIgnoreBlank[comparingIndex], -dimValues.inc[baseIndex]);
						value[index] = SizeChart.sumDoubleValues(this.newValue, -comparingValue);
						dDiff = value[index];
					} else {
						value[index] = SizeChart.sumDoubleValues(dimValues.inc[index], dDiff);
					}

					// Find the next non-blank increment cells and recalculate it to preserve the Relative/Absolute mode value
					var indicesAffectedCell = this._getIndicesOfNextNonEmptyCellsAwayFromBase(index, baseIndex, dimValues.inc);
					if (indicesAffectedCell) {
						for (var i = 0; i < indicesAffectedCell.length; i++)
							value[indicesAffectedCell[i]] = SizeChart.sumDoubleValues(dimValues.inc[indicesAffectedCell[i]], -dDiff);
					}

					cn = this.m_writer.changeNode(this.m_urlNode).changeAttributeKeys(id, type, value);
				} else {
					// if displaying increment values, then use default behavior to just edit single value
					cn = this.inherited(arguments);
				}

				// if dimension showing blanks and non-empty value entered, then set Blanks to false and refresh row
				if (this.getInlineEditValue() && this.getNode().Blanks) {
					cn.changeAttribute("Blanks", xml.ATTR_BOOLEAN, false);
				}
			}

			// any change requires refresh of entire row (mostly due to tolerances)
			this.bRefreshNode = true;

			return cn;
		}
	});
});